import { render, staticRenderFns } from "./BatchStudentUpload.vue?vue&type=template&id=2f09226d&scoped=true"
import script from "./BatchStudentUpload.vue?vue&type=script&lang=js"
export * from "./BatchStudentUpload.vue?vue&type=script&lang=js"
import style0 from "./BatchStudentUpload.vue?vue&type=style&index=0&id=2f09226d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f09226d",
  null
  
)

export default component.exports